<template>
  <module-section :title="title">
    <div class="container">
      <div class="item" v-for="(item, i) in list" :key="i">
        <div class="title">{{ item.name }}</div>
        <div class="img"><img :src="item.img" /></div>
        <div class="intro">{{ item.intro }}</div>
        <div class="btn" v-for="(article, j) in item.contents" :key="j" @click="handleToArticle">{{ article.name }} >>>
        </div>
      </div>
    </div>
  </module-section>
</template>

<script>
import ModuleSection from './ModuleSection.vue'

export default {
  components: {
    ModuleSection
  },
  props: {
    list: {
      type: Array,
      require: true
    },
    title: {
      type: String,
      require: false
    }
  },
  methods: {
    handleToArticle(menu1Id, menu2Id) {
      this.$router.push({
        path: `/article/index?menu1Id=${ menu1Id }&menu2Id=${ menu2Id }`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}

.item {
  margin-right: 30px;
  flex: 1;
  padding: 30px;
  font-size: 18px;
  color: rgb(89, 89, 89);
  text-align: center;
  background-color: rgb(217, 217, 217);

  &:last-child {
    margin-right: 0;
  }

  .title {
    font-weight: 700;
    margin-bottom: 12px;
    font-size: 18px;
    text-align: center;
  }

  .img {
    img {
      margin: 0 auto 24px;
      width: 100%;
    }
  }

  .intro {
    height: 120px;
    font-size: 14px;
  }

  .btn {
    margin-bottom: 10px;
    text-align: left;
    font-weight: 700;
    font-size: 16px;
    color: #b1040e;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
